import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './SharedWishlist';

const SharedWishlistSuspense = dynamic(() => import('./SharedWishlist'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicSharedWishlist(props: Props) {
	return <SharedWishlistSuspense {...props} />;
}
DynamicSharedWishlist.displayName = 'DynamicSharedWishlist';
